import React from 'react'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'
import groupBy from 'lodash/groupBy'
import Typography from '@mui/material/Typography'
import InputField from '../../../../../FormControl/input/InputField'
import Dialog from '../../../../../dialog/Dialog'
import useTerms from '../../../../../../hooks/setting/useTerms'
import {
  ContentTooltiptLearningContinuumInfo,
  useStyles
} from '../../../../Assessment/Classes/MarkingClasses/ContentTooltip/ContentTooltip'
import { useSelector } from 'react-redux'
import { Alert, Table, TableBody, TableRow, TableCell, Tooltip, Box } from '@mui/material'
import InputDateUTC from '../../../../../FormControl/input/InputDateUTC'
import FormatDate from '../../../../../date/FormatDate'

const DialogLcs = ({ show, onClose, data = {}, type }) => {
  const lcs = groupBy(data, 'lcId')

  const classes = useStyles()
  const curriculum = useSelector((state) => state?.assessment?.curriculum || [])
  return (
    <Dialog
      id={`${type}-lcs`}
      show={show}
      title={`${type}`}
      onClose={onClose}
      onCloseHeader={onClose}
      maxWidth={['skills Assessed'].includes(type) ? 'sm' : 'xs'}
    >
      <Table>
        <TableBody>
          {Object.keys(lcs).length === 0 ? (
            <TableRow>
              <TableCell colSpan={2}>{`You don't have any ${type} yet`}</TableCell>
            </TableRow>
          ) : (
            Object.keys(lcs).map((lcId, i) => {
              const lc = lcs[lcId][0]
              const currentCurriculum = curriculum?.find((cur) => cur._id === lc.curriculumId) || {}
              const lcElement = currentCurriculum?.lcElements?.children?.sort(
                (a, b) => b.position - a.position
              )[0]
              const levels = currentCurriculum?.levels || []
              const marking = currentCurriculum?.marking || []
              const teacherMarking =
                lc?.maxLevelTeacher?.completedTeacher &&
                marking?.find((m) => String(m._id) === String(lc.maxLevelTeacher.completedTeacher))
                  ? marking.find((m) => String(m._id) === String(lc.maxLevelTeacher.completedTeacher))
                  : {}
              const studentMarking =
                lc?.maxLevelStudent?.completedStudent &&
                marking?.find((m) => String(m._id) === String(lc.maxLevelStudent.completedStudent))
                  ? marking.find((m) => String(m._id) === String(lc.maxLevelStudent.completedStudent))
                  : {}

              const studentLevel = levels?.find((l) => String(l._id) === String(lc.maxLevelStudent?.levelId))
              const teacherLevel = levels?.find((l) => String(l._id) === String(lc.maxLevelTeacher?.levelId))
              return (
                <TableRow key={lcId} className='mb-4'>
                  <TableCell>
                    <Tooltip
                      arrow
                      placement='top'
                      id={`guttman-chart-table-lc-lc-${lc._id}`}
                      title={
                        <ContentTooltiptLearningContinuumInfo lc={lc} currentCurriculum={currentCurriculum} />
                      }
                      classes={{ tooltip: classes.customWidthGuttmanChart }}
                    >
                      <Typography
                        style={{
                          overflow: 'hidden',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical'
                        }}
                        className=' text-sm flex items-center max-w-200px min-w-200px justify-start'
                      >
                        {lc.lcElements[lcElement?._id] || 'None'}
                      </Typography>
                      {/* {lc._id} */}
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <Box className='flex gap-2 items-center justify-end'>
                      {['growing Skills', 'skills Assessed'].includes(type) && (
                        <Box className='flex flex-col gap-1 items-center text-center'>
                          <Typography
                            variant='body2'
                            color='textSecondary'
                            className='text-2xs font-bold uppercase'
                          >
                            Teacher
                          </Typography>
                          <Box
                            className='flex gap-2 items-center justify-center text-center rounded px-2 py-1 text-sm font-bold'
                            sx={{
                              minWidth: 90,
                              bgcolor: teacherMarking.primaryColor,
                              color: teacherMarking.secondaryColor
                            }}
                          >
                            {teacherLevel?.name || '-'}
                          </Box>
                        </Box>
                      )}
                      {['self Checks', 'skills Assessed'].includes(type) && (
                        <Box className='flex flex-col gap-1 items-center text-center'>
                          <Typography
                            variant='body2'
                            color='textSecondary'
                            className='text-2xs font-bold uppercase'
                          >
                            Student
                          </Typography>
                          <Box
                            className='flex gap-2 items-center justify-center text-center rounded px-2 py-1 text-sm font-bold'
                            sx={{
                              minWidth: 90,
                              bgcolor: studentMarking.primaryColor,
                              color: studentMarking.secondaryColor
                            }}
                          >
                            {studentLevel?.name || '-'}
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              )
            })
          )}
        </TableBody>
      </Table>
    </Dialog>
  )
}

export default DialogLcs
